/**
 * Survey metadata constants used across the application
 * These values are sent with API requests to identify the survey version and client
 */

export const QUESTIONNAIRE_ID = "sleep-assessment-pro-v1";
export const SURVEY_VERSION = "sleep-assessment-pro-v1.0";
export const SURVEY_VARIANT = "standard";
export const API_CLIENT = "sleep-assessment-pro-ui";

export type UnitSystem = "imperial" | "metric";

/** Internal answer key used to store the per-question unit preference map. */
export const UNIT_PREFERENCE_KEY = "unit-preference";

